export default __webpack_public_path__ + "static/pn-0911eddaa4bb5cbf54b8d318c454fe35.svg";